function CardContent( { img, link, title, text, index } ) {
  return (
    <a href={link} className="card" target="_blank" rel="noreferrer">
        <div className="card-img-wrapper">
          <div className="card-img-overlay"></div>
          <img src={img} loading="lazy" alt={title +" "+text} />
        </div>
        <div className="card-text-wrapper">
          <h4>{title}</h4>
          <p>{text}</p>
        </div>
    </a>
  );
}

export default CardContent;
